module.exports = __webpack_public_path__ + "assets/csv/student_advanced_analytics_enabled.csv"